import { useQuery } from '@tanstack/react-query';
import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';
import fetchContactForm from 'app/services/contactForm';
import { ChatCustomization } from 'app/copied/types/ChatItems';

import { ContactFormItem } from '../types';

interface ContactForm {
  ref_id: string;
  completed: boolean;
  dismissable: boolean;
  dismissed: boolean;
  event_dt: string;
  form_parameters: {
    current_page: number;
    form_title: string;
    total_pages: number;
  };
  form_type: string;
  items: ContactFormItem[];
}

export type ContactFormResponse = {
  chat_items: ContactForm[];
  config: {
    title: string;
    customization: ChatCustomization;
  };
};

export const CONTACT_FORM_QUERY_KEY = 'contact-form';

export default function useContactForm(contactFormSlug?: string) {
  const { data: helpCenter } = useFetchHelpCenter();
  const uuid = helpCenter?.uuid;

  return useQuery<ContactFormResponse>({
    queryKey: [CONTACT_FORM_QUERY_KEY, contactFormSlug],
    queryFn: () => fetchContactForm(uuid!, contactFormSlug),
    enabled: !!uuid,
  });
}
